<template>
  <div class="container" id="top-page">
    <v-expansion-panels multiple v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header class="Header"
          >Orders</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <h4 style="font-weight: bold">Search:</h4>
          <input
            class="form-control border input-search"
            id="myInput"
            type="text"
            v-model="search1"
          />
          <div class="filter_date">
            <div class="filter_date_item">
              <h4>From Date:</h4>
              <input type="date" v-model="fromdate1" class="input_date" />
            </div>
            <div class="filter_date_item ml-20">
              <h4>To Date:</h4>
              <input type="date" v-model="todate1" class="input_date" />
            </div>
          </div>
          <br />
          <v-data-table
            v-if="headerItemsFilterDate.length <= 0"
            item-key="name"
            class="elevation-1 table-header"
            loading
            :headers="headersNotfound"
            :items-per-page="5"
            :items="itemNotfound"
            hide-default-footer
            loading-text="Loading... Please wait"
          >
            <template v-slot:top="{ pagination, options, updateOptions }">
              <v-data-footer
                :pagination="pagination"
                :options="options"
                @update:options="updateOptions"
                items-per-page-text="$vuetify.dataTable.itemsPerPageText"
              />
            </template>
          </v-data-table>
          <v-data-table
            v-else
            :headers="orderHeader"
            :items-per-page="5"
            :items="headerItemsFilterDate"
            class="elevation-1 table-header"
            hide-default-footer
            @click:row="handleRowClick"
          >
            <template
              v-for="header in orderHeader"
              v-slot:[`item.${header.value}`]="{ item }"
            >
              <template v-if="isBoolean(item[header.value])">
                <div class="checkbox_container" v-bind:key="item[header.value]">
                  <v-checkbox
                    v-bind:key="item[header.value]"
                    v-model="item[header.value]"
                    :true-value="true"
                    :false-value="false"
                    light
                    disabled
                    color="black"
                  ></v-checkbox>
                </div>
              </template>
              <template v-else>
                {{ item[header.value] }}
              </template>
            </template>
            <template v-slot:top="{ pagination, options, updateOptions }">
              <v-data-footer
                :pagination="pagination"
                :options="options"
                @update:options="updateOptions"
                items-per-page-text="$vuetify.dataTable.itemsPerPageText"
              />
              <v-dialog v-model="dialog" max-width="750px">
                <v-card>
                  <v-card-title>
                    <span class="text-h5">Order Information</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <div v-for="(header, idx) in orderHeader" :key="idx">
                          <v-col cols="auto" sm="auto" md="auto">
                            <v-text-field
                              color="black"
                              v-if="checkIsEmpty(curOrder[header.value])"
                              v-model="emptyItem"
                              :label="header.text"
                              :readonly="true"
                            ></v-text-field>
                            <v-text-field
                              color="black"
                              v-else
                              v-model="curOrder[header.value]"
                              :label="header.text"
                              :readonly="true"
                            ></v-text-field>
                          </v-col>
                        </div>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-btn color="blue darken-1" text @click="close">
                      OK
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="seeDetail">
                      See Order Details
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel style="margin-top: 30px" id="detail">
        <v-expansion-panel-header class="Header"
          >Order Details</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <h4 style="font-weight: bold">Search:</h4>
          <input
            class="form-control border input-search"
            id="myInput"
            type="text"
            v-model="search2"
          />
          <br />
          <tableComponent
            :tableHeaders="orderDetail"
            :tableItems="detailItemsFilterDate"
          >
          </tableComponent>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import tableComponent from "../table/tableComponent.vue";
import { mapGetters } from "vuex";
import DecodeJWT from "../DecodeJWT";

export default {
  components: { tableComponent },
  mounted() {
    let token = localStorage.getItem("token");
    if (token == "" || !token) {
      this.$router.push("/login");
    } else {
      var info = DecodeJWT(token);
      if (info.exp <= new Date().getTime() / 1000) {
        this.$router.push("/login");
      } else {
        window.scrollTo({
          top: document.getElementById("top-page").offsetTop,
          left: 0,
          behavior: "smooth",
        });
        this.panel = Array.from(Array(2).keys());
        this.getBAQOrder();
        const today = new Date();
        const fromday = new Date();
        fromday.setMonth(fromday.getMonth() - 3);
        let year = today.getFullYear();
        let month = (today.getMonth() + 1).toString().padStart(2, "0");
        let day = today.getDate().toString().padStart(2, "0");
        this.todate1 = this.todate2 = `${year}-${month}-${day}`;
        year = fromday.getFullYear();
        month = (fromday.getMonth() + 1).toString().padStart(2, "0");
        day = fromday.getDate().toString().padStart(2, "0");
        this.fromdate1 = this.fromdate2 = `${year}-${month}-${day}`;
      }
    }
  },
  data() {
    return {
      headersNotfound: [{ text: "", value: "nf" }],
      itemNotfound: [{ nf: "Data not found!" }],
      orderHeader: [
        { text: "Cust ID", value: "Customer_CustID" },
        { text: "Name", value: "Customer_Name" },
        { text: "Order", value: "OrderHed_OrderNum" },
        { text: "Order Date", value: "OrderHed_OrderDate" },
        { text: "PO Num", value: "OrderHed_PONum" },
        { text: "FOB", value: "OrderHed_FOB" },
        { text: "Terms", value: "OrderHed_TermsCode" },
        { text: "Ship Via", value: "OrderHed_ShipViaCode" },
        { text: "Currency Code", value: "OrderHed_CurrencyCode" },
        { text: "Ord.Amt", value: "OrderHed_DocOrderAmt" },
        { text: "Open", value: "OrderHed_OpenOrder" },
        { text: "Address", value: "Calculated_Addess" },
      ],
      orderDetail: [
        { text: "Need By", value: "OrderRel_NeedByDate" },
        { text: "Order", value: "OrderDtl_OrderNum" },
        { text: "Line", value: "OrderDtl_OrderLine" },
        { text: "Rel", value: "OrderRel_OrderRelNum" },
        { text: "Part", value: "OrderDtl_PartNum" },
        {
          text: "Line Description",
          value: "OrderDtl_LineDesc",
          class: "min-width2",
        },
        { text: "Our Req. Qty", value: "OrderRel_OurReqQty" },
        { text: "UOM", value: "OrderDtl_IUM" },
      ],
      headerItems: [],
      detailItems: [],
      panel: [],
      curOrder: {},
      search1: "",
      dialog: false,
      emptyItem: " ",
      search2: "",
      fromdate1: "",
      todate1: "",
      fromdate2: "",
      todate2: "",
    };
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 3000);

      this.loader = null;
    },
    getOrderHead() {
      this.loadHeader();
    },
    getOrderDtl() {
      this.loadDetail();
    },
  },
  computed: {
    ...mapGetters("User", ["getUserInfo"]),
    ...mapGetters("Data", ["getOrderHead", "getOrderDtl"]),
    headerItemsFilter() {
      const filterKey = (this.search1 || "").toLowerCase();
      if (this.headerItems == null || filterKey === "") return this.headerItems;
      return this.headerItems.filter((i) => {
        return (
          i.OrderHed_OrderNum.toString().toLowerCase().indexOf(filterKey) > -1
        );
      });
    },
    headerItemsFilterDate() {
      if (this.headerItemsFilter.length > 0) {
        let from = new Date(this.fromdate1);
        let to = new Date(this.todate1);
        return this.headerItemsFilter.filter((i) => {
          let day = i.OrderHed_OrderDate.split("/")[0];
          let month = i.OrderHed_OrderDate.split("/")[1];
          let year = i.OrderHed_OrderDate.split("/")[2];
          let date = new Date(year, month - 1, day);
          return date <= to && from <= date;
        });
      } else {
        return this.headerItemsFilter;
      }
    },
    detailItemsFilter() {
      const filterKey = (this.search2 || "").toLowerCase();
      if (this.detailItems == null || filterKey === "") return this.detailItems;
      return this.detailItems.filter((i) => {
        return (
          i.OrderDtl_OrderLine.toString().toLowerCase().indexOf(filterKey) >
            -1 ||
          i.OrderDtl_PartNum.toString().toLowerCase().indexOf(filterKey) > -1 ||
          i.OrderDtl_LineDesc.toString().toLowerCase().indexOf(filterKey) > -1
        );
      });
    },
    detailItemsFilterDate() {
      if (this.detailItemsFilter.length > 0) {
        // let from = new Date(this.fromdate2);
        // let to = new Date(this.todate2)
        // return this.detailItemsFilter.filter((i) => {
        //   let day = i.InvcHead_InvoiceDate.split('/')[0];
        //   let month = i.InvcHead_InvoiceDate.split('/')[1];
        //   let year = i.InvcHead_InvoiceDate.split('/')[2];
        //   let date = new Date(year, month-1, day);
        //   return date <= to && from <= date;
        // });
        return this.detailItemsFilter;
      } else {
        return this.detailItemsFilter;
      }
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    checkIsEmpty(value) {
      if (typeof value === "string") {
        if (value.length == 0) return true;
        return false;
      }
      if (typeof value === "boolean") {
        return false;
      }
      return false;
    },
    seeDetail() {
      this.dialog = false;
      this.getBAQOrderDetail(this.curOrder);
      window.scrollTo({
        top: document.getElementById("detail").offsetTop,
        left: 0,
        behavior: "smooth",
      });
    },
    isBoolean(value) {
      return typeof value === "boolean";
    },
    handleRowClick(item) {
      this.curOrder = item;
      this.dialog = true;
    },
    convertDate(stringdate) {
      if (stringdate) {
        var dateObject = new Date(stringdate);
        var day = dateObject.getDate().toString().padStart(2, "0");
        var month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
        var year = dateObject.getFullYear();
        return `${day}/${month}/${year}`;
      } else return "";
    },
    async getBAQOrder() {
      await this.$store.dispatch("Data/getOrderHeadData");
      this.loadHeader();
    },
    async getBAQOrderDetail(item) {
      await this.$store.dispatch("Data/getOrderDtlData", {
        order: item.OrderHed_OrderNum,
      });
      this.loadDetail();
    },
    loadHeader() {
      this.headerItems = [];
      if (this.getOrderHead && this.getOrderHead.length > 0) {
        this.getOrderHead.forEach((el) => {
          this.headerItems.push({
            Customer_CustID: el.Customer_CustID,
            Customer_Name: el.Customer_Name,
            OrderHed_OrderNum: el.OrderHed_OrderNum,
            OrderHed_OrderDate: this.convertDate(el.OrderHed_OrderDate),
            OrderHed_PONum: el.OrderHed_PONum,
            OrderHed_FOB: el.OrderHed_FOB,
            OrderHed_TermsCode: el.OrderHed_TermsCode,
            OrderHed_ShipViaCode: el.OrderHed_ShipViaCode,
            OrderHed_CurrencyCode: el.OrderHed_CurrencyCode,
            OrderHed_DocOrderAmt: el.OrderHed_DocOrderAmt,
            OrderHed_OpenOrder: el.OrderHed_OpenOrder,
            Calculated_Addess: el.Calculated_Addess,
          });
        });
      }
    },
    loadDetail() {
      this.detailItems = [];
      if (this.getOrderDtl && this.getOrderDtl.length > 0) {
        this.getOrderDtl.forEach((el) => {
          this.detailItems.push({
            OrderRel_NeedByDate: this.convertDate(el.OrderRel_NeedByDate),
            OrderDtl_OrderNum: el.OrderDtl_OrderNum,
            OrderDtl_OrderLine: el.OrderDtl_OrderLine,
            OrderRel_OrderRelNum: el.OrderRel_OrderRelNum,
            OrderDtl_PartNum: el.OrderDtl_PartNum,
            OrderDtl_LineDesc: el.OrderDtl_LineDesc,
            OrderRel_OurReqQty: el.OrderRel_OurReqQty,
            OrderDtl_IUM: el.OrderDtl_IUM,
          });
        });
      }
    },
  },
};
</script>

<style scoped>
.ml-20 {
  margin-left: 100px;
}
.input_date {
  outline: #d1dfe3;
}
.filter_date {
  display: flex;
  flex-direction: row;
}
.filter_date_item {
  display: flex;
  flex-direction: column;
}
.mb-20 {
  margin-bottom: 50px;
}
.Header {
  font-weight: 700;
  font-size: 1.2em;
  color: white;
  background-color: #d1dfe3;
  color: black;
}
.table-custom {
  width: 100%;
  margin-top: 20px;
}
table,
th,
td {
  border: 1px solid #ddd;
  height: 50px;
  border-collapse: collapse;
}
th {
  border-bottom: 2px solid black;
}
td {
  text-align: center;
}
.input-search {
  margin-top: 5px;
  margin-bottom: 10px;
  outline: #d1dfe3;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #ddd;
}
.hidden {
  display: none !important;
}

a:hover {
  font-weight: bolder;
}

.switchTabMsg {
  text-align: center;
  width: fit-content;
  color: black !important;
  text-decoration: underline;
}

.passwordRules {
  margin-top: -25px;
  margin-left: 15px;
  font-size: small;
  opacity: 0.6;
}
</style>
